export default "__VITE_ASSET__i80sApW2__"